export function initPort(app) {
  app.ports.showToast &&
    app.ports.showToast.subscribe(function(x) {
      app.ports.receiveToast && app.ports.receiveToast.send(x);
    });
}
